/** @format */

import {Box} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import BaseSearchModal from 'components/BaseSearchModal';
import {TanStackTableData} from 'components/Table/core/types';

import {TOOLTIP_TEXTS, goalColumns, MAX_GOAL_SELECTIONS} from '../Form/constants';
import FieldLabelWithHelp from '../Form/components/FieldLabelWithHelp';
import {GoalOptionsInterface} from '../../types';

interface GoalsFieldProps {
  goals: string[];
  goalOptions: (GoalOptionsInterface & TanStackTableData)[];
  onGoalChange: (goalIds: string[]) => void;
  disabled?: boolean;
}

const GoalsField = ({goals, goalOptions, onGoalChange, disabled = false}: GoalsFieldProps) => {
  const {t} = useTranslation();

  return (
    <Box>
      <FieldLabelWithHelp tooltipText={TOOLTIP_TEXTS.GOALS}>
        <Trans>Цели из Метрики</Trans>
      </FieldLabelWithHelp>
      <BaseSearchModal
        columns={goalColumns}
        data={goalOptions}
        modalTitle={t('Выбрать цели из Метрики')}
        searchPlaceholder={t('Название или ID')}
        confirmButtonText={t('Выберите до {{count}} целей', {count: MAX_GOAL_SELECTIONS})}
        searchByColumnIds={['counterId', 'counterName', 'id', 'name']}
        initialSelectedIds={goals}
        maxSelections={MAX_GOAL_SELECTIONS}
        onConfirm={onGoalChange}
        disabled={disabled}
        getDisplayLabel={(item: TanStackTableData) => String(item.name || item.id || '')}
      />
    </Box>
  );
};

export default GoalsField;
